import {
  CashIcon,
  CubeIcon,
  CurrencyDollarIcon,
  DocumentDuplicateIcon,
  LocationMarkerIcon,
  MapIcon,
  NewspaperIcon,
  OfficeBuildingIcon,
  TemplateIcon,
  UserGroupIcon,
  TableIcon,
  DocumentReportIcon,
  DocumentTextIcon,
} from "@heroicons/react/solid";

export const widgetsIcon: { [key: string]: JSX.Element } = {
  REBUILD_INVENTORY: <DocumentDuplicateIcon className="h-5 w-5" />,
  REBUILD_LOANS_APPROVED: <CubeIcon className="h-5 w-5" />,
  TOTAL_DEVELOPERS: <UserGroupIcon className="h-5 w-5" />,
  TOTAL_PROJECTS: <OfficeBuildingIcon className="h-5 w-5" />,
  PROJECT_LOCATION: <LocationMarkerIcon className="h-5 w-5" />,
  PROJECTS_BY_NEIGHBORHOOD: <MapIcon className="h-5 w-5" />,
  PROJECT_BUDGET_SUMMARY: <CashIcon className="h-5 w-5" />,
  PROJECT_FINANCIAL: <CurrencyDollarIcon className="h-5 w-5" />,
  PROJECT_STATUS_SUMMARY: <NewspaperIcon className="h-5 w-5" />,
  PROJECTS_BY_PROJECT_TYPE: <OfficeBuildingIcon className="h-5 w-5" />,
  PROJECTS_BY_CONSTRUCTION_TYPE: <TemplateIcon className="h-5 w-5" />,
  TASKS_COUNT: <TableIcon className="h-5 w-5" />,
  DELIVERABLES_COUNT: <DocumentTextIcon className="h-5 w-5" />,
  MILESTONES_COUNT: <DocumentReportIcon className="h-5 w-5" />,
};
